import { render, staticRenderFns } from "./GearInfo.vue?vue&type=template&id=dcc9b186&scoped=true&"
import script from "./GearInfo.vue?vue&type=script&lang=js&"
export * from "./GearInfo.vue?vue&type=script&lang=js&"
import style0 from "./GearInfo.vue?vue&type=style&index=0&id=dcc9b186&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc9b186",
  null
  
)

export default component.exports